<template>
  <v-dialog
    v-model="model"
    transition="dialog-bottom-transition"
    :max-width="maxWidth"
  >
    <v-card>
      <v-toolbar
        color="primary"
        dark
      >{{ title }}
      </v-toolbar>
      <v-card-text class="mt-5">
        <v-row>
          <v-text-field
            type="date"
            :min="activeProfile.birthdate"
            :max="currentDate"
            label="Дата измерения"
            v-model="measure.dt"
            :persistent-hint="true"
            :hint="hintDate"
            :error="errorsDate.length > 0"
            :error-messages="errorsDate"
          >
            <template v-slot:prepend>
              <v-icon>{{ mdiCalendar }}</v-icon>
            </template>
          </v-text-field>
        </v-row>
        <v-row>
          <v-text-field
            type="number"
            label="Рост (см)"
            v-model="measure.stature"
            :error="errorsStature.length > 0"
            :error-messages="errorsStature"
          >
            <template v-slot:prepend>
              <v-icon>{{ mdiHumanMaleHeightVariant }}</v-icon>
            </template>
          </v-text-field>
        </v-row>
        <v-row>
          <v-text-field
            type="number"
            label="Вес (кг)"
            v-model="measure.weight"
            :error="errorsWeight.length > 0"
            :error-messages="errorsWeight"
          >
            <template v-slot:prepend>
              <v-icon>{{ mdiScale }}</v-icon>
            </template>
          </v-text-field>
        </v-row>
      </v-card-text>
      <v-card-actions class="justify-end">
        <v-btn
          color="primary"
          :disabled="allErrors.length > 0"
          @click="saveMeasure(measure)"
        >Сохранить
        </v-btn>
        <v-btn
          text
          @click="$emit('close')"
        >Отмена
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import {
  mdiCalendar,
  mdiHumanMaleHeightVariant,
  mdiScale
} from '@mdi/js'

import config from '@/app/config'
import measureDB from '@/app/measure'
import utils from '@/app/utils'

export default {
  props: {
    value: {
      type: Boolean,
      default: false
    },
    measure: {
      type: Object,
      default: function () {
        return {
          dt: '',
          stature: '',
          weight: ''
        }
      }
    },
    title: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      mdiCalendar,
      mdiHumanMaleHeightVariant,
      mdiScale
    }
  },
  computed: {
    model: {
      get () {
        return this.value
      },
      set (value) {
        this.$emit('input', value)
      }
    },
    errorsDate () {
      let errors = []
      if (!this.measure.dt) {
        errors.push('Введите дату измерения')
      }
      return errors
    },
    errorsStature () {
      let errors = []
      if (this.measure.stature && (this.measure.stature < config.graphs.stature.yMin || this.measure.stature > config.graphs.stature.yMax)) {
        errors.push('Заданный рост не будет отражён на графике, убедитесь, что вы ввели рост в сантиметрах')
      }
      return errors
    },
    errorsWeight () {
      let errors = []
      if (this.measure.weight && (this.measure.weight < config.graphs.weight.yMin || this.measure.weight > config.graphs.weight.yMax)) {
        errors.push('Заданный вес не будет отражён на графике, убедитесь, что вы ввели вес в килограммах')
      }
      return errors
    },
    allErrors () {
      return [
        ...this.errorsDate,
        ...this.errorsStature,
        ...this.errorsWeight
      ]
    },
    maxWidth () {
      return config.maxWidth
    },
    activeProfile () {
      return this.$store.state.profile
    },
    hintDate () {
      return measureDB.getAgeInHuman(this.activeProfile, this.measure)
    },
    currentDate () {
      return utils.getDateYmd(new Date())
    }
  },
  methods: {
    saveMeasure (measure) {
      measureDB.save(measure).then((measureId) => {
        if (!measure.id) {
          measure.id = measureId
        }
        this.$emit('save', measure)
      })
    }
  }
}
</script>
